module.exports = __webpack_public_path__ + "img/zanorari08.b1bc462c.jpg";